import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    deleteDailyMachine,
    DeleteDailyMachineResponse,
    createDailyMachine,
    DailyMachineResponse,
    updateDailyMachine,
    UpdateDailyMachineBody,
    UpdateDailyMachineQueries,
    DeleteDailyMachineQueries,
} from '../../services/apiSLTP/dailyReports/dailyMachines';

type UseDeleteDailyMachineMutationOptions = MutationOptions<DeleteDailyMachineResponse, Error, { id: string; queries?: DeleteDailyMachineQueries }>;

export const useDeleteDailyMachineMutation = (options?: UseDeleteDailyMachineMutationOptions) => {
    const deleteDailyMachineMutation: MutationFunction<DeleteDailyMachineResponse, { id: string; queries?: DeleteDailyMachineQueries }> = async ({
        id,
        queries,
    }) => {
        try {
            const response: DeleteDailyMachineResponse = await deleteDailyMachine(id, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily machine');
        }
    };

    return useMutation(deleteDailyMachineMutation, options);
};

type UseCreateDailyMachineMutationOptions = MutationOptions<
    DailyMachineResponse,
    Error,
    { activityId: string; machineId: string; state: number; isUsed: boolean; createTransfer?: boolean; quantity: number; unitPrice?: number }
>;

export const useCreateDailyMachineMutation = (options?: UseCreateDailyMachineMutationOptions) => {
    const createDailyMachineMutation: MutationFunction<
        DailyMachineResponse,
        { activityId: string; machineId: string; state: number; isUsed: boolean; createTransfer?: boolean; quantity?: number; unitPrice?: number }
    > = async ({ activityId, machineId, state, isUsed, createTransfer, quantity, unitPrice }) => {
        try {
            const response: DailyMachineResponse = await createDailyMachine(
                activityId,
                machineId,
                state,
                createTransfer,
                undefined,
                undefined,
                quantity,
                unitPrice
            );
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily machine');
        }
    };

    return useMutation(createDailyMachineMutation, options);
};

type UseDailyMachineMutationOptions = MutationOptions<
    DailyMachineResponse,
    Error,
    { id: string; body: UpdateDailyMachineBody; queries?: UpdateDailyMachineQueries }
>;

export const useDailyMachineMutation = (options?: UseDailyMachineMutationOptions) => {
    const updateDailyMachineMutation: MutationFunction<
        DailyMachineResponse,
        { id: string; body: UpdateDailyMachineBody; queries?: UpdateDailyMachineQueries }
    > = async ({ id, body, queries }) => {
        try {
            const response: DailyMachineResponse = await updateDailyMachine(id, body, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily machine');
        }
    };

    return useMutation(updateDailyMachineMutation, options);
};
